export const accInit = () => {
    const accBtn = document.querySelectorAll(".acc__txt");

    accBtn.forEach((accBtnList) => {
        if (innerWidth > 1024 && accBtnList.classList.contains("sponly")) {
            return;
        }

        const ans =
            accBtnList.previousElementSibling !== null
                ? accBtnList.previousElementSibling
                : accBtnList.nextElementSibling;

        const originalHeight = ans.clientHeight;

        let height = ((originalHeight + 1) / window.innerWidth) * 100;
        ans.style.height = "0vw";

        accBtnList.addEventListener("click", () => {
            openAcc();
        });

        function openAcc() {
            const accBtnParent = accBtnList.parentNode;
            accBtnParent.classList.toggle("is-on");

            if (accBtnParent.classList.contains("is-on")) {
                ans.style.height = `${height}vw`;
            } else {
                ans.style.height = "0vw";
                if (accBtnList.classList.contains("scrollback")) {
                    scrollTo({
                        top: scrollY - originalHeight,
                        behavior: "smooth",
                    });
                }
            }
        }
    });
};

accInit();
